import { useRouterState } from "@tanstack/react-router";
import { useEffect, useMemo } from "react";
import { useOrganization } from "@/contexts/organization-context";
import { useCurrentUser } from "@/hooks/use-current-user";
import { setSentryAppContext, setSentryIdentity } from "@/lib/sentry";
import { matchWorkspaceLocation } from "@/routing/core/locations";

export function getSentryRouteFamily(pathname: string): string {
  if (pathname === "/") return "home";
  if (pathname.startsWith("/auth")) return "auth";
  if (pathname.startsWith("/error")) return "error";
  if (pathname.startsWith("/settings")) return "settings";

  const workspace = matchWorkspaceLocation(pathname);
  if (workspace) return workspace.kind;

  return "app";
}

export function SentryContextSync() {
  const currentUser = useCurrentUser();
  const { organizationId } = useOrganization();
  const pathname = useRouterState({ select: (state) => state.location.pathname });

  const appContext = useMemo(() => {
    const workspace = matchWorkspaceLocation(pathname);
    return {
      routeFamily: getSentryRouteFamily(pathname),
      workspaceKind: workspace?.kind,
    };
  }, [pathname]);

  useEffect(() => {
    setSentryIdentity({
      userId: currentUser?._id,
      orgId: organizationId ?? undefined,
    });
  }, [currentUser?._id, organizationId]);

  useEffect(() => {
    setSentryAppContext(appContext);
  }, [appContext]);

  return null;
}
